/*========================================================================
* $Id: editor.js 97320 2017-04-07 11:14:01Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "service/stub",
 "client/application",
  "utils/persistedsourceinfo",
  "utils/clone",
  "i18n/i18n",
  "jquery",
  "underscore",
  "backbone",
  "moment",
  "utils/uuid",
  "api/v2/export"
], function (
  Stub,
  Application,
  PersistedSourceinfo,
  clone,
  i18n,
  $,
  _,
  Backbone,
  moment,
  UUID,
  Export
) {
  var PATH = ["queryexports", "default"];

  var queryexportAvailable = {};

  var DEFAULT_EXPORT_TIMEOUT = 60000;

  function execute(apiPath/*: string*/, channels/*: Channels*/, request, success/*: function*/, error/*: function */) {

    var adaptedStub = Stub.extend({
      channelPrepareRequestOverride: function(request, channel) {
        try {
          channel.prepareRequest(request);
          if (request.create) {
            var data = JSON.parse(request.create.data);
            channel.prepareRequest(data);
            request.create.data = JSON.stringify(data);
          }
        } catch (e) {}
      }
    });

    var serviceStub = new adaptedStub({path: apiPath});

    var responseObserver = createResponseObserver();
    
    var numberOfChannels = channels.length;
    var finished = 0;

    responseObserver.on("response", function (response, channel) {
        finished++; if (finished >= numberOfChannels) responseObserver.off();
        success && success.apply(this, arguments);
    });
    responseObserver.on("error", function () {
        finished++; if (finished >= numberOfChannels) responseObserver.off();
        error && error.apply(this, arguments);
    });
    serviceStub.cast(channels, request, responseObserver);
  }

  function available(application, channels, success, error) {
    var listOfChannelsWithResults = getListOfChannelsWithResults(application);
    channels.each(function (channel) {
      if (listOfChannelsWithResults.indexOf(channel.id) >= 0) {
        var id = channel.get("id");
        var available = queryexportAvailable[id];

        var persistedresourcesfound = PersistedSourceinfo.persistedcollectionschemaAvailable("queryexports", application, true);

        if (persistedresourcesfound) {
          success && success({ status: { success: true } }, channel);
        } else {
          error && error({ status: { success: false } }, channel);
        }
      }
    });
  }

  function create(channels/*: Channels*/, data/*: string*/, success/*: function*/, error/*: function */) {
    execute("persistedresources", channels, {
      create: {
        path: PATH,
        data: data
      }
    }, success, error);
  }

  function getListOfChannelsWithResults(application) {
    var availableChannelsInResults = [];
    
    var results = application.models.search.get("resultset.results");
    _.each(results, function (model) { 
      if (availableChannelsInResults.indexOf(model.channel.id) === -1) {
        availableChannelsInResults.push(model.channel.id);
      }
    });
    
    var perServiceDataset = application.models.search.get("resultset.per_service_dataset");
    _.each(perServiceDataset, function (service) {
      if (service.termination_cause === "COUNT_LIMIT") {
        if (availableChannelsInResults.indexOf(service.id) === -1) {
          availableChannelsInResults.push(service.id);
        }
      }
    });

    return availableChannelsInResults;
  }

  function getResponseResource(response) {
    return response && response.persisted_resources && response.persisted_resources[0] || false;
  }

  function getResponseResourcePath(response) {
    return response &&
      response.persisted_resources &&
      response.persisted_resources[0] &&
      response.persisted_resources[0].path.join("/")
      || '';
  }

  function getResponseProperties(resource) {
    var properties = {};
    _.each(resource && resource.property, function (entry) {
      properties[entry.key] = entry.value;
    });
    return properties;
  }

  function getProgressStatus(response) {
    var progress = 0;

    var resource = getResponseResource(response);
    var properties = getResponseProperties(resource);

    return properties && properties.progress || progress;
  }

  function createResponseObserver() {
    var responseObserver = {};
    return _.extend(responseObserver, Backbone.Events);
  }

  function exportIsInProgress(response) {
    var resource = getResponseResource(response);
    var properties = getResponseProperties(resource);

    var status = properties["status"];
    if (status === "PROGRESS") return true;

    return false;
  }

  function checkRequestStatus(channel, path, task, that) {
    execute("persistedresources", channel, {
      read: {
        path: path
      }
    }, function(response) {

      if (exportIsInProgress(response)) {

        var progress = getProgressStatus(response);
        task.update("", { 
          progressAvailable: true,
          progress: progress
        });
        setTimeout(function() {
          checkRequestStatus(channel, path, task, that)
        }, 5000);
        return;
        
      } else {
        
        var resource = getResponseResource(response);
        var properties = getResponseProperties(resource);
        var status = properties["status"];
        if (status == "SUCCESS") {
          task.finish();
          var exportUrl = "export?resource_path=" + getResponseResourcePath(response);
          
          channel.call(
            exportUrl,
            {},
            null,
            { responseType: "blob" },
            null,
            { method: "post", defaultAjaxRequestTimeoutInMs: DEFAULT_EXPORT_TIMEOUT }
          );

        } else {
          task.stop("", {status: status});
        }

        if (!$('.mb-export-is-running').length) that.removeExportDownloadBlinker();
      }

    }, function(response) {});
  }

  function runExport(exportRequest, runner, persistedresourcesfound) {
    var loaderLeft = $('.loaderLeft');
    loaderLeft.show();

    if($('.mb-no-export-results').length){
      loaderLeft.empty();
    }

    var that = this;
    var exportService = this.api.exportsearch.createStub();
    var channels = this.models.search.wiring.channel;

    var task = this.models.tasks.push({
      id: exportRequest.id,
      name: i18n("results_exportSearch"),
      currentTime: exportRequest.currentTime,
      searchQuery:exportRequest.searchQuery
    });

    task.start();

    task.update("", {
      progressAvailable: persistedresourcesfound,
      progress: 0
    });

    task.on("change:cancelled", function(task, tasks, options) {
        if (task.isCancelled()) {
          var cancelRequest = _.clone(exportRequest);
          cancelRequest.cancel_pending = true;
          exportService.cast(channels, cancelRequest, null);
          // TODO: abort download???
          task.destroy();
          if (!$('.mb-export-is-running').length) that.removeExportDownloadBlinker();
        }
    });

    runner.call(this, task, exportService);
  }

  function runQueryExport(response, channel) {
    return function (task) {
      var that = this;
      var exportUrl = "exportAsync?resource_path=" + getResponseResourcePath(response);
      var serviceStub = new Stub({ path: exportUrl });

      var taskresponse = response;
      var responseObserver = createResponseObserver();
      responseObserver.once("response", function (response, channel) {
        var checkRequestPath = taskresponse.persisted_resources[0].path;
        checkRequestStatus(channel, checkRequestPath, task, that);
      });

      responseObserver.once("error", function (response, channel) {
        if (response && (response.status === 404 || response.status === 500)) {
          runSyncExport(channel, task, taskresponse);
        } else {
          task.finish();  
        }
      });
      
      serviceStub.cast(
        channel,
        {},
        responseObserver,
        {
          ignoreTriggerDone: true,
          ignoreTriggerFail: true
        }
      );
    };
  }

  function runSyncExport(channel, task, taskResponse) {
    task.update("", {
      progressAvailable: null,
      progress: 0
    });

    var serviceStub = new Export.ExportServiceStub({
      path: "export?resource_path=" + getResponseResourcePath(taskResponse)
    });

    var responseObserver = createResponseObserver();

    responseObserver.once("all", function (response, channel) {
      task.finish();
    });

    var options = {};
    if (channel.messageFrame) {
      options = { method: 'download' };
    }

    serviceStub.cast(channel, { export_format: "text/csv" }, responseObserver, options);
  }

  function runDirectExport(exportRequest, channel) {
    return function (task, exportService) {
      var that = this;
      var promise = exportService.cast(channel, exportRequest);

      promise.always(function() {
          if (task.isRunning()) {
            task.finish();
            if (!$('.mb-export-is-running').length) that.removeExportDownloadBlinker();
          }
      });
    };
  }

  if (!Application.prototype.exportSearch) {
    _.extend(Application.prototype, {

        exportSearch: function(options, traceContext) {
          options = options || {};
          
          var searchRequest = this.models.search.input.toJSON();
          var userContext = this.getUserContext();
          var currentTimestamp = moment();
          var currentTime = currentTimestamp.format("HH:mm");
          var id = _.uniqueId();
          //TODO searchQuery.user = undefined?!
          var searchQuery = searchRequest.user && searchRequest.user.query.and[0].unparsed;

          if (this.options.exportProperties) {
            
            var transformedProps = [];
            var keys = _.keys(this.options.exportProperties);
            // Transform {url: {format: [..]}} -> [{name: "url", format: [..]}]
            for (var j = 0; j < keys.length; ++j) {
              var name = keys[j].replace('[\"', '').replace('\"]', '');
              var format = this.options.exportProperties[keys[j]] ? this.options.exportProperties[keys[j]]['formats'] : [];
              transformedProps.push({ name: name, format: format});
            }
          
            searchRequest.properties = transformedProps;
          }

          if (options.properties) {
            searchRequest.properties = options.properties;
          }

          var excludePropertiesFromTranslation = this.options.excludeFromTranslation;

          _.each(excludePropertiesFromTranslation, _.bind(function(prop) {
            _.find(searchRequest.properties, function(val) {
              if (val.name == prop) {
                val.localized_name = prop
              }
            });
          }, this));

          var exportRequest = {
            search_request: searchRequest,
            id: searchQuery + '_' + currentTime + '_' + UUID.generate(),
            currentTime: currentTime,
            searchQuery:searchQuery,
            user_context: userContext
          };

          if (options.exportFormat !== 'undefined') exportRequest.export_format = options.exportFormat;



          available(this,
            this.models.channels,
          _.bind(function (response, channel) {
            create(channel, JSON.stringify(exportRequest), _.bind(function (response, channel) {
              var channelID = channel.id;
              var persistedresourcesfound = false;

              var persistedresourcesfound = PersistedSourceinfo.persistedcollectionschemaAvailable("queryexports", this, true);

              if (persistedresourcesfound) {
                runExport.call(this, exportRequest, runQueryExport(response, channel), persistedresourcesfound);
              } else {
                // xls export is not save the old way
                exportRequest.export_format = "text/csv";
                runExport.call(this, exportRequest, runDirectExport(exportRequest, channel));
              }

            }, this));
          }, this),
          _.bind(function (response, channel) {
            // xls export is not save the old way
            exportRequest.export_format = "text/csv";
            runExport.call(this, exportRequest, runDirectExport(exportRequest, channel));
          }, this));
        },

        cancel: function(options) {
          options.model.cancel();
          if (!$('.mb-export-progress').length) {
            this.hideExportDownload();
          }
        },

        deleteExportEl: function(options){
          options.model.destroy();
          this.isTaskExporting();
        },

        isTaskExporting: function(){
          if(!$('.mb-export-finished').length) {
            this.hideExportDownload();
          }
        },

        hideExportDownload: function() {
          $('.loaderLeft').hide();
          $('.showExportList').css("color","#808080");
          this.removeExportDownloadBlinker();
        },

        removeExportDownloadBlinker: function() {
          $('.showExportList').removeClass("exportDownloaderBlink");
        },

        showExports: function(){
          $('.loaderLeft').toggle();
          var inProgress = $('.loaderLeft').find(".mb-export-progress");
          var finised = $('.loaderLeft').find(".mb-export-finished");
          if(!inProgress.length && !finised.length){
            $('.loaderLeft').html('<span class="mb-no-export-results"><b>' + i18n('no_exports_available') + '</b></span>');
          }
        }
    });
  }
});
